// extracted by mini-css-extract-plugin
export default {"assigneePickerContainer":"ItemPickerAssigneeBase-module__assigneePickerContainer--o7zPA"};